// src/components/common/ModalPortal.js
//
// Puts a popup straight under <body>, so it always sits on top of the whole
// page and in the middle of the screen.
//
// Why: a popup with `position: fixed` is only fixed to the SCREEN when none
// of its parents has a transform, filter or animation. The dashboard's
// profile card and the subject pages have those, so the shop and leaderboard
// were being positioned inside the card — off to the side, partly hidden,
// and behind other things. Rendering them here avoids every parent.

import { useEffect } from "react";
import "./modal.css";
import { createPortal } from "react-dom";

// While any popup is open, <body> has the class "sbl-modal-open" — used to
// hide things like the "Show Tips" button behind the popup.
let openCount = 0;

const ModalPortal = ({ children }) => {
  useEffect(() => {
    openCount += 1;
    document.body.classList.add("sbl-modal-open");
    return () => {
      openCount = Math.max(0, openCount - 1);
      if (!openCount) document.body.classList.remove("sbl-modal-open");
    };
  }, []);
  if (typeof document === "undefined") return children;
  return createPortal(children, document.body);
};

export default ModalPortal;
